import { createLogic } from "redux-logic";
import {
  FETCH_SHELVES,
  SET_FOUND_SHELVES,
  REPORT_MISSING_ITEM,
  SET_REPORT_MISSING_ITEM,
  SET_MISSING_SKU_FOUND,
  SET_MISSING_SKU_FOUND_LOADING,
  FORCE_LIFT_SHELF,
  CANCEL_LIFT_SHELF,
  setForcedLiftShelves,
  setCurrentShelf,
  setForceLiftShelfFailed,
  resetVerifyForceLiftShelf,
  FETCH_SETTING_AUTOSTORE_SKU_REMOVAL_DISABLED,
  SET_AUTOSTORE_SKU_REMOVAL_DISABLED,
} from "../reducers/missingSkuReducer";
import SkuEndpoints from "../../sku/SkuEndpoints";
import VerticalLiftEndpoints from "../../verticallift/VerticalLiftEndpoints";
import { MissingStockItemMissingReason , AUTOSTORE_SHELF} from "../../../utils/Constants";
import WorkstationEndpoints from "../../workstation/WorkstationEndpoints";

const fetchShelvesLogic = createLogic({
  type: FETCH_SHELVES,
  validate({ _, action }, allow, reject) {
    const boxItem = action.boxItem;
    if (!isNaN(boxItem.skuID)) {
      allow(action);
    } else {
      const missingAmount = boxItem.reservedQuantity - boxItem.verifiedQuantity;
      reject({ type: SET_FOUND_SHELVES, foundShelves: [], missingAmount: missingAmount });
    }
  },
  async process({ _, action }, dispatch, done) {
    const boxItem = action.boxItem;
    const branchId = action.branchId;
    const missingAmount = boxItem.reservedQuantity - boxItem.verifiedQuantity;
    await SkuEndpoints.getStockListForSku(boxItem.skuID, branchId)
      .then((data) => {
        if (data.length < 10 && !data.some(x=> x.shelfNumber === boxItem.shelfNumber) && boxItem.shelfNumber !== AUTOSTORE_SHELF){
          data.push({name:"", shelfNumber: boxItem.shelfNumber,stockQuantity: 0, isLiftShelf: false, channels: []});
        }
        dispatch({
          type: SET_FOUND_SHELVES,
          foundShelves: data,
          missingAmount: missingAmount,
        });
        done();
      })
      .catch(() => {
        dispatch({
          type: SET_FOUND_SHELVES,
          foundShelves: [],
          missingAmount: missingAmount,
        });
        done();
      });
  },
});

const reportMissingItemLogic = createLogic({
  type: REPORT_MISSING_ITEM,
  process({ _, action }, dispatch, done) {
    const { boxItem, reason } = action.payload;

    SkuEndpoints.reportMissingStockItem(boxItem, reason)
      .then((res) => {
        dispatch({
          type: SET_REPORT_MISSING_ITEM,
          payload: {
            missingStockItemID: res.itemID,
            reasonCode: reason,
          },
        });
        done();
      })
      .catch(() => {
        dispatch({
          type: SET_REPORT_MISSING_ITEM,
          payload: {
            missingStockItemID: 0,
            reasonCode: MissingStockItemMissingReason.Unknown,
          },
        });
        done();
      });
  },
});

const setMissingSkuFoundLogic = createLogic({
  type: SET_MISSING_SKU_FOUND,
  process({ _, action }, dispatch, done) {
    const {
      shelves,
      boxItem,
      missingAmount,
      fromReview,
      callback,
      successCallback,
      failureCallback,
      operatorId,
      isScanIdValidationRemoveSkuRequired,
      partialDelivery,
      isRxItem,
    } = action.payload;
    const skuID = boxItem.skuID;
    const boxID = boxItem.boxID;

    dispatch({
      type: SET_MISSING_SKU_FOUND_LOADING,
      missingButtonLoading: true,
    });

    SkuEndpoints.setFoundQuantity(
      skuID,
      boxID,
      shelves,
      missingAmount,
      fromReview,
      operatorId,
      isScanIdValidationRemoveSkuRequired,
      partialDelivery,
      isRxItem,
      boxItem.shelfNumber
    )
      .then((res) => {
        if (successCallback) successCallback();
        callback(res);
      })
      .catch((error) => {
        if (failureCallback) failureCallback(error);
      })
      .finally(() => {
        dispatch({
          type: SET_MISSING_SKU_FOUND_LOADING,
          missingButtonLoading: false,
        });
        done();
      });
  },
});

const forceLiftShelfLogic = createLogic({
  type: FORCE_LIFT_SHELF,
  process({ getState, action }, dispatch, done) {
    const state = getState();
    const forcedLiftShelvesFromState = state.missingSkuReducer.forcedLiftShelves;
    const { shelfNumber, cartID } = action;

    VerticalLiftEndpoints.forceManualShelf(shelfNumber, cartID)
      .then(() => {
        const forcedLiftShelves = [...forcedLiftShelvesFromState, shelfNumber];
        dispatch(setForcedLiftShelves(forcedLiftShelves));
        dispatch(resetVerifyForceLiftShelf());
        done();
      })
      .catch(() => {
        dispatch(setForceLiftShelfFailed());
        done();
      });
  },
});

const cancelLiftShelfLogic = createLogic({
  type: CANCEL_LIFT_SHELF,
  process({ getState, action }, dispatch, done) {
    const state = getState();
    const forcedLiftShelvesFromState = state.missingSkuReducer.forcedLiftShelves;
    const { shelfNumber, cartID } = action;

    VerticalLiftEndpoints.cancelLiftShelf(shelfNumber, cartID).finally(() => {
      const forcedLiftShelves = [...forcedLiftShelvesFromState.filter((a) => a !== shelfNumber)];
      dispatch(setForcedLiftShelves(forcedLiftShelves));
      dispatch(setCurrentShelf(""));
      done();
    });
  },
});


const autostoreSkuRemovalDisabledLogic = createLogic({
  type: FETCH_SETTING_AUTOSTORE_SKU_REMOVAL_DISABLED,
  process({ getState }, dispatch, done) {
    const state = getState();
    const { workstationID} = state.loginInfoReducer 

    WorkstationEndpoints.isAutostoreSkuRemovalDisabled(workstationID)
    .then((res) => {
      dispatch({
        type: SET_AUTOSTORE_SKU_REMOVAL_DISABLED,
        enabled: res,
      });
    }).finally(() => {
      done();
    });
  },
});

export {
  autostoreSkuRemovalDisabledLogic,
  fetchShelvesLogic,
  reportMissingItemLogic,
  setMissingSkuFoundLogic,
  forceLiftShelfLogic,
  cancelLiftShelfLogic,
};
